import { Component, OnInit } from '@angular/core';
import { VisitVehicleService } from '../../services/visit-vehicle.service';
import { VisitVehicle } from '../../models/visit-vehicle.entity';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Department } from '../../../parametrization/models/department';
import { DepartmentService } from '../../services/department.service';
import { AuthenticationService } from '../../../../services/authentication.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'authorized-visit',
  templateUrl: './authorized-visit.component.html',
  styleUrls: ['./authorized-visit.component.scss'],
})
export class AuthorizedVisitComponent implements OnInit {
  visit: any;
  errorMessage = null;
  /**
   * Departments array
   */
  departments: Department[];
  constructor(
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private visitVehicleService: VisitVehicleService,
    private departmentService: DepartmentService,
    private authService: AuthenticationService
  ) {
    this.visit = {};
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.departmentService.list().subscribe((departments: Department[]) => {
        this.departments = departments;
        this.visitVehicleService.findFiltered({ visitId: params.visitId }).subscribe((visitVehicle: any) => {
          if (visitVehicle.length > 0) {
            this.visit = visitVehicle[0];
            if (this.visit.authorized) {
              this.errorMessage = 'La visita ' + this.visit.visitId + ' ya ha sido autorizada';
            } else {
              const department: any = this.departments.filter((department) => department.id === this.visit.departamentId);
              this.visit.departmentName = department[0].description;
              let a = 1;
            }
          } else {
            this.errorMessage = 'No se encuentra registrada la visita ' + params.visitId;
          }
        });
      });
    });
  }

  authorizedVisit() {
    this.visitVehicleService
      .update({
        visitId: this.visit.visitId,
        authorized: true,
        userAuthorization: this.authService.currentUser.name,
        authorizationDate: new Date(),
      } as VisitVehicle)
      .subscribe(
        () => {
          this.snackBar.open('Visita autorizada satisfactoriamente', null, {
            duration: 15000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        },
        (error) => {
          this.snackBar.open('Error al autorizar la visita', null, {
            duration: 15000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        }
      );
  }
}
